/* Byteful Studio 2.0 · ücretsiz araçlar */
(function () {
  'use strict';

  if (window.__bytefulTools) return;
  window.__bytefulTools = true;

  var reducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var NOTE_KEY = 'bd-brief-note';

  var trCurrency = new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', maximumFractionDigits: 0 });
  var trInt = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 0 });
  var trDec1 = new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 1 });
  var trDec2 = new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  var trDec2Loose = new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

  function track(name, data) {
    var payload = data || {};
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (error) { /* analitik isteğe bağlıdır */ }
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (error) { /* yok say */ }
  }

  function saveNote(text) {
    try { window.sessionStorage.setItem(NOTE_KEY, text); } catch (error) { /* gizli sekme */ }
  }
  function readNote() {
    try { return window.sessionStorage.getItem(NOTE_KEY) || ''; } catch (error) { return ''; }
  }
  function clearNote() {
    try { window.sessionStorage.removeItem(NOTE_KEY); } catch (error) { /* yok say */ }
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function withParams(url, params) {
    try {
      var target = new URL(url, window.location.origin);
      Object.keys(params).forEach(function (key) {
        if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
          target.searchParams.set(key, params[key]);
        }
      });
      return target.pathname + target.search + target.hash;
    } catch (error) {
      return url;
    }
  }

  /* Türkçe sayı girişi: 50.000 · 1,5 · 4.5 */
  function parseNumber(raw) {
    var s = String(raw || '').replace(/[^\d.,-]/g, '');
    if (!s) return NaN;
    if (s.indexOf(',') > -1) {
      s = s.replace(/\./g, '').replace(',', '.');
    } else if (/^\d{1,3}(\.\d{3})+$/.test(s)) {
      s = s.replace(/\./g, '');
    }
    return parseFloat(s);
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  /* ---------------------------------------------------------------
     ROAS ve kârlılık hesaplayıcı
     --------------------------------------------------------------- */
  class BdRoas extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.values = {
        cpc: parseFloat(this.dataset.cpc) || 4,
        margin: parseFloat(this.dataset.margin) || 45
      };
      this.out = {};
      this.querySelectorAll('[data-out]').forEach(function (el) {
        this.out[el.dataset.out] = el;
      }.bind(this));
      this.fill = this.querySelector('[data-meter-fill]');
      this.mark = this.querySelector('[data-meter-mark]');

      this.fields = Array.prototype.slice.call(this.querySelectorAll('.bd-calc__field')).map(function (el) {
        var field = {
          key: el.dataset.key,
          min: parseFloat(el.dataset.min),
          max: parseFloat(el.dataset.max),
          scale: el.dataset.scale,
          format: el.dataset.format,
          step: parseFloat(el.dataset.step) || 1,
          input: el.querySelector('[data-input]'),
          range: el.querySelector('[data-range]')
        };
        var initial = parseNumber(field.input.value);
        field.value = isNaN(initial) ? field.min : clamp(initial, field.min, field.max);
        this.values[field.key] = field.value;
        this.bindField(field);
        this.syncField(field, true);
        return field;
      }.bind(this));

      this.compute();
      this.tracked = false;

      var cta = this.querySelector('.bd-calc__cta');
      if (cta) {
        cta.addEventListener('click', function () {
          if (this.noteText) saveNote(this.noteText);
        }.bind(this));
      }
    }

    bindField(field) {
      var self = this;
      field.range.addEventListener('input', function () {
        field.value = self.fromRange(field, parseFloat(field.range.value));
        self.values[field.key] = field.value;
        self.syncField(field, true);
        self.compute(true);
      });
      field.input.addEventListener('input', function () {
        var value = parseNumber(field.input.value);
        if (isNaN(value) || value <= 0) return;
        field.value = clamp(value, field.min, field.max * 20);
        self.values[field.key] = field.value;
        self.syncField(field, false);
        self.compute(true);
      });
      field.input.addEventListener('blur', function () {
        field.value = clamp(field.value, field.min, field.max * 20);
        self.syncField(field, true);
      });
      field.input.addEventListener('focus', function () {
        field.input.select();
      });
      field.input.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown') return;
        event.preventDefault();
        var direction = event.key === 'ArrowUp' ? 1 : -1;
        var step = field.scale === 'log' ? self.niceStep(field.value) : field.step;
        if (event.shiftKey) step *= 10;
        field.value = clamp(self.round(field, field.value + direction * step), field.min, field.max * 20);
        self.values[field.key] = field.value;
        self.syncField(field, true);
        self.compute(true);
      });
    }

    niceStep(value) {
      if (value < 1000) return 10;
      if (value < 10000) return 100;
      if (value < 100000) return 1000;
      return 5000;
    }

    round(field, value) {
      if (field.scale === 'log') {
        var step = this.niceStep(value);
        return Math.round(value / step) * step;
      }
      var decimals = field.step < 1 ? 1 : 0;
      return parseFloat((Math.round(value / field.step) * field.step).toFixed(decimals));
    }

    toRange(field, value) {
      var v = clamp(value, field.min, field.max);
      if (field.scale === 'log') {
        return Math.round(1000 * Math.log(v / field.min) / Math.log(field.max / field.min));
      }
      return Math.round(1000 * (v - field.min) / (field.max - field.min));
    }

    fromRange(field, position) {
      var value;
      if (field.scale === 'log') {
        value = field.min * Math.pow(field.max / field.min, position / 1000);
      } else {
        value = field.min + (field.max - field.min) * position / 1000;
      }
      return clamp(this.round(field, value), field.min, field.max);
    }

    display(field) {
      if (field.format === 'currency') return trInt.format(field.value);
      if (field.format === 'money2') return trDec2Loose.format(field.value);
      return trDec1.format(field.value);
    }

    syncField(field, writeInput) {
      if (writeInput) field.input.value = this.display(field);
      var position = this.toRange(field, field.value);
      field.range.value = position;
      field.range.style.setProperty('--p', (position / 10) + '%');
    }

    compute(fromUser) {
      var v = this.values;
      var budget = v.budget || 0;
      var cpc = v.cpc || 1;
      var cvr = v.cvr || 0;
      var aov = v.aov || 0;
      var margin = clamp(v.margin || 1, 1, 100) / 100;

      var clicks = budget / cpc;
      var orders = clicks * cvr / 100;
      var revenue = orders * aov;
      var roas = budget > 0 ? revenue / budget : 0;
      var breakeven = 1 / margin;
      var cpa = orders > 0 ? budget / orders : 0;
      var profit = revenue * margin - budget;

      this.set('revenue', trCurrency.format(revenue));
      this.set('roas', trDec2.format(roas) + 'x');
      this.set('orders', trInt.format(orders));
      this.set('clicks', trInt.format(clicks));
      this.set('cpa', orders > 0 ? trCurrency.format(cpa) : '-');
      this.set('breakeven', trDec2.format(breakeven) + 'x');
      this.set('profit', trCurrency.format(profit));
      if (this.out.profit) this.out.profit.style.color = profit >= 0 ? '' : '#e8826d';
      if (this.out.roas) this.out.roas.style.color = roas >= breakeven ? '' : '#e8826d';

      var status;
      var color;
      var text;
      var beText = trDec2.format(breakeven) + 'x';
      if (roas >= breakeven * 1.2) {
        status = 'good';
        color = '#86c79f';
        text = 'Kârlı görünüyor. ROAS değerin başa baş noktası olan ' + beText + ' seviyesinin üzerinde. Bu tabloda reklam harcaman brüt kârınla rahatça karşılanıyor.';
      } else if (roas >= breakeven) {
        status = 'warn';
        color = '#e2a94f';
        text = 'Başa baş noktasına yakınsın. ' + beText + ' seviyesinin hemen üzerindesin. Sepet tutarında veya dönüşüm oranında küçük bir artış kârlılığı belirgin şekilde değiştirir.';
      } else {
        status = 'bad';
        color = '#e8826d';
        text = 'Bu varsayımlarla reklam zarar ettiriyor. Zarar etmemek için ROAS değerin en az ' + beText + ' olmalı. Dönüşüm oranı, sepet tutarı veya tıklama maliyeti tarafında iyileştirme gerekir.';
      }
      if (this.out.verdict) {
        this.out.verdict.textContent = text;
        this.out.verdict.style.setProperty('--verdict', color);
        this.out.verdict.dataset.status = status;
      }

      var scaleMax = Math.max(breakeven * 2, roas * 1.15, 1);
      if (this.fill) {
        this.fill.style.setProperty('--fill', Math.min(100, (roas / scaleMax) * 100) + '%');
        this.fill.style.setProperty('--meter', color);
      }
      if (this.mark) this.mark.style.setProperty('--mark', Math.min(100, (breakeven / scaleMax) * 100) + '%');

      if (this.out.tip) {
        var better = clicks * (cvr + 0.5) / 100 * aov;
        var delta = better - revenue;
        this.out.tip.innerHTML = 'Dönüşüm oranın %' + escapeHtml(trDec1.format(cvr)) + ' değil %' +
          escapeHtml(trDec1.format(cvr + 0.5)) + ' olsaydı, aynı bütçeyle aylık ciron yaklaşık <strong>' +
          escapeHtml(trCurrency.format(delta)) + '</strong> daha yüksek olurdu.';
      }

      this.noteText = 'ROAS hesabım: aylık bütçe ' + trCurrency.format(budget) +
        ', tıklama maliyeti ₺' + trDec2Loose.format(cpc) +
        ', dönüşüm oranı %' + trDec1.format(cvr) +
        ', sepet tutarı ' + trCurrency.format(aov) +
        ', brüt kâr marjı %' + trDec1.format(margin * 100) +
        ', tahmini ROAS ' + trDec2.format(roas) + 'x.';

      if (fromUser && !this.tracked) {
        this.tracked = true;
        track('byteful_tool_used', { tool: 'roas' });
      }
    }

    set(key, value) {
      if (this.out[key]) this.out[key].textContent = value;
    }
  }

  /* ---------------------------------------------------------------
     Büyüme Skoru
     --------------------------------------------------------------- */
  var AREA_NAMES = {
    ads: 'Reklam & ölçümleme',
    store: 'Mağaza & dönüşüm',
    content: 'İçerik & kreatif',
    email: 'E-posta & sadakat'
  };

  var LEVELS = [
    { min: 90, color: 'var(--good)', level: 'Ölçeklemeye hazır', title: 'Altyapın çok güçlü.', text: 'Temeller yerinde görünüyor. Sıradaki adım, kazanan kanalları kontrollü şekilde büyütmek ve yeni pazarları test etmek.' },
    { min: 70, color: 'var(--good)', level: 'Güçlü bir altyapı', title: 'İyi durumdasın.', text: 'Büyümenin temelleri sağlam. Bundan sonraki kazanç ince ayarlardan, kreatif testlerinden ve e-posta otomasyonlarından gelecek.' },
    { min: 40, color: 'var(--warn)', level: 'Gelişmeye açık', title: 'Önünde önemli fırsatlar var.', text: 'Bazı temeller yerinde ama birkaç kritik eksik büyümeni yavaşlatıyor. Doğru önceliklerle kısa sürede belirgin ilerleme mümkün.' },
    { min: 0, color: 'var(--bad)', level: 'Temel eksikler var', title: 'Önce sağlam bir zemin.', text: 'Büyümenin önünde birkaç engel var. İşin iyi yanı, bu alanlar genellikle en hızlı sonuç verenlerdir.' }
  ];

  class BdGrowthScore extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.screens = {
        start: this.querySelector('[data-screen="start"]'),
        quiz: this.querySelector('[data-screen="quiz"]'),
        result: this.querySelector('[data-screen="result"]')
      };
      this.questions = Array.prototype.slice.call(this.querySelectorAll('.bd-score__q'));
      this.answers = new Array(this.questions.length);
      this.index = 0;
      this.pointerAnswer = false;
      this.bar = this.querySelector('[data-score-bar]');
      this.count = this.querySelector('[data-score-count]');
      this.prev = this.querySelector('[data-score-prev]');
      this.ctaBase = this.dataset.ctaUrl || '/pages/iletisim';
      if (!this.questions.length) return;

      this.addNextButton();

      var startButton = this.querySelector('[data-score-start]');
      if (startButton) startButton.addEventListener('click', this.start.bind(this));
      var restart = this.querySelector('[data-score-restart]');
      if (restart) restart.addEventListener('click', this.restart.bind(this));
      if (this.prev) this.prev.addEventListener('click', function () { this.go(this.index - 1); }.bind(this));

      this.screens.quiz.addEventListener('pointerdown', function (event) {
        if (event.target.closest('.bd-choice')) this.pointerAnswer = true;
      }.bind(this));
      this.screens.quiz.addEventListener('keydown', function () { this.pointerAnswer = false; }.bind(this));
      this.screens.quiz.addEventListener('submit', function (event) { event.preventDefault(); });

      this.questions.forEach(function (question, i) {
        question.addEventListener('change', function (event) {
          var input = event.target;
          if (!input || input.type !== 'radio') return;
          this.answers[i] = { value: parseInt(input.value, 10) || 0, unknown: input.hasAttribute('data-unknown') };
          this.updateNav();
          if (this.pointerAnswer) {
            this.pointerAnswer = false;
            window.clearTimeout(this.advanceTimer);
            this.advanceTimer = window.setTimeout(function () {
              this.next();
            }.bind(this), 320);
          }
        }.bind(this));
      }.bind(this));
    }

    addNextButton() {
      var nav = this.querySelector('.bd-score__nav');
      if (!nav) return;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'bd-btn bd-btn--dark bd-btn--sm';
      button.innerHTML = '<span class="bd-btn__label">İleri</span><span class="bd-btn__icon"><svg class="bd-icon" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 12h15M13.5 6l6 6-6 6"/></svg></span>';
      button.addEventListener('click', this.next.bind(this));
      nav.appendChild(button);
      this.nextButton = button;
    }

    show(name) {
      Object.keys(this.screens).forEach(function (key) {
        if (this.screens[key]) this.screens[key].hidden = key !== name;
      }.bind(this));
    }

    start() {
      this.show('quiz');
      this.go(0);
      track('byteful_tool_used', { tool: 'growth_score' });
    }

    restart() {
      this.answers = new Array(this.questions.length);
      this.questions.forEach(function (q) {
        q.querySelectorAll('input').forEach(function (input) { input.checked = false; });
      });
      this.start();
    }

    go(i) {
      if (i < 0 || i >= this.questions.length) return;
      this.index = i;
      this.questions.forEach(function (q, n) {
        q.hidden = n !== i;
        q.classList.toggle('is-entering', n === i && !reducedQuery.matches);
      });
      var total = this.questions.length;
      if (this.bar) this.bar.style.width = ((i + 1) / total * 100) + '%';
      if (this.count) this.count.textContent = (i + 1) + ' / ' + total;
      this.updateNav();
      var legend = this.questions[i].querySelector('.bd-score__question');
      if (legend) {
        legend.setAttribute('tabindex', '-1');
        legend.focus({ preventScroll: true });
      }
      this.keepInView();
    }

    keepInView() {
      var rect = this.getBoundingClientRect();
      if (rect.top < 80 || rect.top > window.innerHeight * 0.6) {
        this.scrollIntoView({ behavior: reducedQuery.matches ? 'auto' : 'smooth', block: 'start' });
      }
    }

    updateNav() {
      if (this.prev) this.prev.disabled = this.index === 0;
      if (this.nextButton) {
        var answered = !!this.answers[this.index];
        this.nextButton.disabled = !answered;
        this.nextButton.style.opacity = answered ? '' : '.35';
        var label = this.nextButton.querySelector('.bd-btn__label');
        if (label) label.textContent = this.index === this.questions.length - 1 ? 'Sonucu gör' : 'İleri';
      }
    }

    next() {
      if (!this.answers[this.index]) return;
      if (this.index < this.questions.length - 1) {
        this.go(this.index + 1);
      } else {
        this.finish();
      }
    }

    finish() {
      var totals = {};
      var sum = 0;
      var max = 0;
      var misses = [];
      this.questions.forEach(function (q, i) {
        var area = q.dataset.area || 'ads';
        var weight = parseInt(q.dataset.weight, 10) || 1;
        var answer = this.answers[i] || { value: 0, unknown: true };
        if (!totals[area]) totals[area] = { sum: 0, max: 0 };
        totals[area].sum += answer.value * weight;
        totals[area].max += 2 * weight;
        sum += answer.value * weight;
        max += 2 * weight;
        if (answer.value < 2 && q.dataset.rec) {
          misses.push({
            gap: (2 - answer.value) * weight,
            order: i,
            unknown: answer.unknown,
            rec: q.dataset.rec,
            question: (q.querySelector('.bd-score__question') || {}).textContent || '',
            area: area
          });
        }
      }.bind(this));

      var score = max ? Math.round(sum / max * 100) : 0;
      var level = LEVELS.filter(function (l) { return score >= l.min; })[0];

      this.show('result');
      var result = this.screens.result;
      var gauge = result.querySelector('[data-score-gauge]');
      var valueEl = result.querySelector('[data-score-value]');
      result.style.setProperty('--gauge', level.color);
      result.querySelector('[data-score-level]').textContent = level.level;
      result.querySelector('[data-score-title]').textContent = level.title;
      result.querySelector('[data-score-text]').textContent = level.text;

      if (gauge) {
        gauge.style.setProperty('--value', 0);
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () { gauge.style.setProperty('--value', score); });
        });
      }
      this.countTo(valueEl, score);

      var areasEl = result.querySelector('[data-score-areas]');
      var areaSummary = [];
      if (areasEl) {
        areasEl.innerHTML = '';
        Object.keys(AREA_NAMES).forEach(function (key) {
          if (!totals[key]) return;
          var pct = Math.round(totals[key].sum / totals[key].max * 100);
          areaSummary.push({ key: key, pct: pct });
          var row = document.createElement('div');
          row.className = 'bd-area-row';
          row.setAttribute('data-area', key);
          row.innerHTML = '<span class="bd-area-row__name">' + escapeHtml(AREA_NAMES[key]) + '</span>' +
            '<span class="bd-area-row__bar"><span></span></span>' +
            '<span class="bd-area-row__val">' + pct + '</span>';
          areasEl.appendChild(row);
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () { row.querySelector('.bd-area-row__bar span').style.width = pct + '%'; });
          });
        });
      }

      misses.sort(function (a, b) { return b.gap - a.gap || a.order - b.order; });
      var recsEl = result.querySelector('[data-score-recs]');
      var recsWrap = recsEl ? recsEl.parentElement : null;
      if (recsEl) {
        recsEl.innerHTML = '';
        misses.slice(0, 3).forEach(function (miss) {
          var li = document.createElement('li');
          li.innerHTML = '<span><strong>' + escapeHtml(AREA_NAMES[miss.area] || '') + '</strong>' + escapeHtml(miss.rec) +
            (miss.unknown ? '<small>Bu soruya “Bilmiyorum” dedin. Önce mevcut durumu birlikte kontrol edelim.</small>' : '') + '</span>';
          recsEl.appendChild(li);
        });
        if (recsWrap) recsWrap.hidden = misses.length === 0;
      }

      var weakest = areaSummary.slice().sort(function (a, b) { return a.pct - b.pct; }).slice(0, 2)
        .map(function (a) { return AREA_NAMES[a.key] + ' (' + a.pct + '/100)'; }).join(', ');
      saveNote('Büyüme Skoru sonucum: ' + score + '/100. En zayıf alanlarım: ' + weakest + '.');

      var cta = result.querySelector('[data-score-cta]');
      if (cta) cta.setAttribute('href', withParams(this.ctaBase, { kaynak: 'buyume-skoru', skor: score }));

      track('byteful_tool_completed', { tool: 'growth_score', score: score });
      result.focus({ preventScroll: true });
      this.keepInView();
    }

    countTo(el, target) {
      if (!el) return;
      if (reducedQuery.matches) {
        el.textContent = target;
        return;
      }
      var start = performance.now();
      function tick(now) {
        var progress = Math.min(1, (now - start) / 1300);
        el.textContent = Math.round(target * (1 - Math.pow(1 - progress, 3)));
        if (progress < 1) window.requestAnimationFrame(tick);
      }
      window.requestAnimationFrame(tick);
    }
  }

  /* ---------------------------------------------------------------
     Site hız testi (Google PageSpeed Insights)
     --------------------------------------------------------------- */
  var SPEED_STEPS = [
    'Sayfan Google sunucularında açılıyor…',
    'Görseller ve yazı tipleri ölçülüyor…',
    'Etkileşim hızı hesaplanıyor…',
    'Düzen kaymaları kontrol ediliyor…',
    'Sonuçlar hazırlanıyor…'
  ];

  var METRICS = [
    { id: 'largest-contentful-paint', label: 'En büyük içerik (LCP)', type: 'sec', hint: 'Ana içeriğin görünme süresi' },
    { id: 'first-contentful-paint', label: 'İlk içerik (FCP)', type: 'sec', hint: 'İlk öğenin görünme süresi' },
    { id: 'total-blocking-time', label: 'Engelleme süresi (TBT)', type: 'ms', hint: 'Sayfanın tepkisiz kaldığı süre' },
    { id: 'cumulative-layout-shift', label: 'Düzen kayması (CLS)', type: 'cls', hint: 'Yüklenirken içerik kayması' },
    { id: 'speed-index', label: 'Hız indeksi', type: 'sec', hint: 'Görünür içeriğin dolma hızı' }
  ];

  function statusColor(score) {
    if (score === null || score === undefined) return 'var(--muted)';
    if (score >= 0.9) return 'var(--good)';
    if (score >= 0.5) return 'var(--warn)';
    return 'var(--bad)';
  }

  function normalizeUrl(raw) {
    var value = String(raw || '').trim();
    if (!value) return null;
    if (!/^https?:\/\//i.test(value)) value = 'https://' + value;
    try {
      var url = new URL(value);
      if (!/\./.test(url.hostname) || /\s/.test(value)) return null;
      return url.href;
    } catch (error) {
      return null;
    }
  }

  class BdSpeedTest extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="url"]');
      this.error = this.querySelector('[data-speed-error]');
      this.loading = this.querySelector('[data-speed-loading]');
      this.status = this.querySelector('[data-speed-status]');
      this.result = this.querySelector('[data-speed-result]');
      this.fallback = this.querySelector('[data-speed-fallback]');
      this.key = (this.dataset.key || '').trim();
      this.ctaBase = this.dataset.ctaUrl || '/pages/iletisim';
      if (!this.form) return;

      this.form.addEventListener('submit', this.run.bind(this));
      this.querySelectorAll('[data-speed-again]').forEach(function (button) {
        button.addEventListener('click', this.reset.bind(this));
      }.bind(this));

      try {
        var params = new URLSearchParams(window.location.search);
        if (params.get('site') && this.input) this.input.value = params.get('site');
      } catch (error) { /* yok say */ }
    }

    reset() {
      this.result.hidden = true;
      this.fallback.hidden = true;
      this.loading.hidden = true;
      this.form.hidden = false;
      if (this.input) this.input.focus();
    }

    showError(message) {
      this.error.textContent = message;
      this.error.hidden = false;
    }

    run(event) {
      event.preventDefault();
      this.error.hidden = true;
      var url = normalizeUrl(this.input.value);
      if (!url) {
        this.showError('Geçerli bir site adresi yaz. Örnek: markan.com');
        this.input.focus();
        return;
      }
      var strategyInput = this.form.querySelector('input[name="strategy"]:checked');
      var strategy = strategyInput ? strategyInput.value : 'mobile';
      this.url = url;
      this.strategy = strategy;

      this.form.hidden = true;
      this.result.hidden = true;
      this.fallback.hidden = true;
      this.loading.hidden = false;
      this.rotateStatus();
      track('byteful_tool_used', { tool: 'speed_test' });

      var params = new URLSearchParams();
      params.set('url', url);
      params.set('strategy', strategy);
      params.set('locale', 'tr');
      params.append('category', 'performance');
      if (this.key) params.set('key', this.key);

      var controller = 'AbortController' in window ? new AbortController() : null;
      var timeout = window.setTimeout(function () { if (controller) controller.abort(); }, 90000);

      fetch('https://www.googleapis.com/pagespeedonline/v5/runPagespeed?' + params.toString(), controller ? { signal: controller.signal } : {})
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (data) {
            return { ok: response.ok, status: response.status, data: data };
          });
        })
        .then(function (res) {
          window.clearTimeout(timeout);
          this.stopStatus();
          if (res.ok && res.data && res.data.lighthouseResult) {
            this.render(res.data);
            return;
          }
          var status = res.status;
          var message = res.data && res.data.error && res.data.error.message ? String(res.data.error.message) : '';
          if (status === 429 || status === 403 || /quota/i.test(message)) {
            this.showFallback('quota');
          } else if (/FAILED_DOCUMENT_REQUEST|ERRORED_DOCUMENT_REQUEST|DNS_FAILURE|NOT_HTML/i.test(message)) {
            this.loading.hidden = true;
            this.form.hidden = false;
            this.showError('Bu adrese ulaşılamadı. Adresi kontrol edip tekrar dene.');
          } else {
            this.showFallback('error');
          }
        }.bind(this))
        .catch(function () {
          window.clearTimeout(timeout);
          this.stopStatus();
          this.showFallback('error');
        }.bind(this));
    }

    rotateStatus() {
      var i = 0;
      this.status.textContent = SPEED_STEPS[0];
      this.statusTimer = window.setInterval(function () {
        i = Math.min(i + 1, SPEED_STEPS.length - 1);
        this.status.textContent = SPEED_STEPS[i];
      }.bind(this), 5000);
    }

    stopStatus() {
      window.clearInterval(this.statusTimer);
    }

    showFallback(kind) {
      this.loading.hidden = true;
      this.fallback.hidden = false;
      var title = this.fallback.querySelector('[data-speed-fallback-title]');
      var text = this.fallback.querySelector('[data-speed-fallback-text]');
      if (title && text) {
        if (kind === 'quota') {
          title.textContent = 'Google test kotası şu an dolu.';
          text.textContent = "Testi aynı adresle doğrudan PageSpeed Insights'ta açabilir ya da bizden ücretsiz hız analizi isteyebilirsin.";
        } else {
          title.textContent = 'Test şu an tamamlanamadı.';
          text.textContent = "Google'ın ölçüm servisi şu an yanıt vermiyor. Testi PageSpeed Insights'ta açabilir ya da bizden ücretsiz hız analizi isteyebilirsin.";
        }
      }
      var psi = this.fallback.querySelector('[data-speed-psi]');
      if (psi) psi.href = 'https://pagespeed.web.dev/report?url=' + encodeURIComponent(this.url || '');
      var cta = this.fallback.querySelector('[data-speed-cta]');
      if (cta) cta.href = withParams(this.ctaBase, { kaynak: 'hiz-testi', site: this.url });
      saveNote('Site hız analizi istiyorum: ' + (this.url || ''));
    }

    render(data) {
      var lr = data.lighthouseResult;
      var audits = lr.audits || {};
      var perf = lr.categories && lr.categories.performance ? lr.categories.performance : { score: 0, auditRefs: [] };
      var score = Math.round((perf.score || 0) * 100);
      var root = this.result;

      var title;
      var text;
      if (score >= 90) {
        title = 'Siten hızlı.';
        text = 'Performans çok iyi. Yeni uygulama, video veya görsel eklerken bu seviyeyi korumaya dikkat et.';
      } else if (score >= 50) {
        title = 'Hızlanmaya açık.';
        text = 'Fena değil ama her saniye önemli. Aşağıdaki fırsatlar dönüşüm oranını ve reklam verimini doğrudan etkileyebilir.';
      } else {
        title = 'Siten yavaş.';
        text = 'Ziyaretçilerin bir kısmı sayfa açılmadan ayrılıyor olabilir. Aşağıdaki iyileştirmelerle başlamanı öneririz.';
      }
      root.style.setProperty('--gauge', statusColor(perf.score));
      root.querySelector('[data-speed-title]').textContent = title;
      root.querySelector('[data-speed-text]').textContent = text;
      var host = '';
      try { host = new URL(this.url).hostname.replace(/^www\./, ''); } catch (error) { host = this.url; }
      root.querySelector('[data-speed-site]').textContent = host + ' · ' + (this.strategy === 'desktop' ? 'Masaüstü' : 'Mobil');

      var gauge = root.querySelector('[data-speed-gauge]');
      var scoreEl = root.querySelector('[data-speed-score]');
      if (gauge) {
        gauge.style.setProperty('--value', 0);
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () { gauge.style.setProperty('--value', score); });
        });
      }
      if (scoreEl) scoreEl.textContent = score;

      var metricsEl = root.querySelector('[data-speed-metrics]');
      metricsEl.innerHTML = '';
      METRICS.forEach(function (metric) {
        var audit = audits[metric.id];
        if (!audit || typeof audit.numericValue !== 'number') return;
        var value;
        if (metric.type === 'sec') value = trDec1.format(audit.numericValue / 1000) + ' sn';
        else if (metric.type === 'ms') value = trInt.format(audit.numericValue) + ' ms';
        else value = trDec2.format(audit.numericValue);
        var wrap = document.createElement('div');
        wrap.className = 'bd-metric';
        wrap.style.setProperty('--status', statusColor(audit.score));
        wrap.innerHTML = '<dt>' + escapeHtml(metric.label) + '</dt><dd>' + escapeHtml(value) + '<small>' + escapeHtml(metric.hint) + '</small></dd>';
        metricsEl.appendChild(wrap);
      });

      var ops = [];
      (perf.auditRefs || []).forEach(function (ref) {
        if (ref.group === 'metrics' || ref.group === 'hidden') return;
        var audit = audits[ref.id];
        if (!audit || audit.score === null || audit.score === undefined || audit.score >= 0.9) return;
        if (['notApplicable', 'manual', 'informative', 'error'].indexOf(audit.scoreDisplayMode) > -1) return;
        var savings = 0;
        if (audit.metricSavings) {
          Object.keys(audit.metricSavings).forEach(function (k) { savings += Number(audit.metricSavings[k]) || 0; });
        }
        if (audit.details && typeof audit.details.overallSavingsMs === 'number') savings += audit.details.overallSavingsMs;
        ops.push({ title: audit.title || '', value: audit.displayValue || '', weight: savings + (1 - audit.score) * 100 });
      });
      ops.sort(function (a, b) { return b.weight - a.weight; });
      var opsWrap = root.querySelector('[data-speed-ops-wrap]');
      var opsList = root.querySelector('[data-speed-ops]');
      opsList.innerHTML = '';
      ops.slice(0, 4).forEach(function (op) {
        var li = document.createElement('li');
        var clean = String(op.title).replace(/`/g, '');
        li.innerHTML = '<span><strong>' + escapeHtml(clean) + '</strong>' + (op.value ? '<small>' + escapeHtml(String(op.value).replace(/`/g, '')) + '</small>' : '') + '</span>';
        opsList.appendChild(li);
      });
      opsWrap.hidden = ops.length === 0;

      var shot = root.querySelector('[data-speed-shot]');
      var shotData = audits['final-screenshot'] && audits['final-screenshot'].details ? audits['final-screenshot'].details.data : '';
      if (shot && shotData && /^data:image\//.test(shotData)) {
        shot.src = shotData;
        shot.alt = host + ' ekran görüntüsü';
        shot.hidden = false;
      } else if (shot) {
        shot.hidden = true;
      }

      root.querySelectorAll('[data-speed-cta]').forEach(function (link) {
        link.href = withParams(this.ctaBase, { kaynak: 'hiz-testi', site: this.url, skor: score });
      }.bind(this));
      saveNote('Site Hız Testi sonucum: ' + host + ' ' + (this.strategy === 'desktop' ? 'masaüstü' : 'mobil') + ' skoru ' + score + '/100.');

      this.loading.hidden = true;
      root.hidden = false;
      root.focus({ preventScroll: true });
      track('byteful_tool_completed', { tool: 'speed_test', score: score });
    }
  }

  /* ---------------------------------------------------------------
     Brief formu (iletişim formu)
     --------------------------------------------------------------- */
  var SOURCE_LABELS = {
    'buyume-skoru': 'Büyüme Skoru',
    'hiz-testi': 'Site Hız Testi',
    'roas': 'ROAS & Kâr Hesaplayıcı',
    'on-inceleme': 'Ücretsiz ön inceleme talebi'
  };

  class BdPlanner extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.form = this.closest('form');
      this.steps = Array.prototype.slice.call(this.querySelectorAll('.bd-planner__step'));
      if (!this.form || !this.steps.length) return;
      this.classList.add('is-enhanced');
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-step-dot]'));
      this.bar = this.querySelector('[data-planner-bar]');
      this.prevButton = this.querySelector('[data-planner-prev]');
      this.nextButton = this.querySelector('[data-planner-next]');
      this.submitButton = this.querySelector('[data-planner-submit]');
      this.needsField = this.querySelector('[data-planner-needs]');
      this.sourceField = this.querySelector('[data-planner-source]');
      this.body = this.querySelector('[data-planner-body]');
      this.brief = document.querySelector('[data-bd-brief]');
      this.briefList = this.brief ? this.brief.querySelector('[data-brief-list]') : null;
      this.needs = Array.prototype.slice.call(this.querySelectorAll('input[data-need]'));

      this.needs.forEach(function (box) {
        box.dataset.name = box.name;
        box.removeAttribute('name');
      });

      this.applyParams();

      this.prevButton.addEventListener('click', function () { this.show(this.current - 1); }.bind(this));
      this.nextButton.addEventListener('click', function () {
        if (this.validate(this.current)) this.show(this.current + 1);
      }.bind(this));
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.form.addEventListener('change', this.updateBrief.bind(this));
      this.form.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' && event.target.tagName === 'INPUT' && event.target.type !== 'submit' && this.current < this.steps.length - 1) {
          event.preventDefault();
          if (this.validate(this.current)) this.show(this.current + 1);
        }
      }.bind(this));

      var start = this.dataset.hasErrors === 'true' ? this.steps.length - 1 : 0;
      this.show(start, true);
      this.updateBrief();
    }

    applyParams() {
      var params;
      try { params = new URLSearchParams(window.location.search); } catch (error) { return; }
      var wanted = params.get('hizmet');
      if (wanted) {
        this.needs.forEach(function (box) {
          if (box.dataset.key === wanted) box.checked = true;
        });
      }
      var site = params.get('site');
      var siteField = this.form.querySelector('input[name="contact[Web sitesi]"]');
      if (site && siteField && !siteField.value) siteField.value = site;

      var source = params.get('kaynak');
      if (source && this.sourceField) {
        var label = SOURCE_LABELS[source] || source;
        var score = params.get('skor');
        this.sourceField.value = label + (score ? ' (skor ' + score + '/100)' : '');
      }
      var note = readNote();
      if (note && this.body && !this.body.value.trim()) this.body.value = note + '\n\n';
    }

    show(index, silent) {
      var total = this.steps.length;
      var i = Math.max(0, Math.min(total - 1, index));
      this.current = i;
      this.steps.forEach(function (step, n) {
        step.classList.toggle('is-current', n === i);
        var err = step.querySelector('[data-step-error]');
        if (err && n !== i) err.hidden = true;
      });
      this.dots.forEach(function (dot, n) {
        dot.classList.toggle('is-active', n === i);
        dot.classList.toggle('is-done', n < i);
      });
      if (this.bar) this.bar.style.width = ((i + 1) / total * 100) + '%';
      this.prevButton.hidden = i === 0;
      this.nextButton.hidden = i === total - 1;
      this.submitButton.hidden = i !== total - 1;
      if (!silent) {
        var legend = this.steps[i].querySelector('.bd-planner__legend');
        if (legend) {
          legend.setAttribute('tabindex', '-1');
          legend.focus({ preventScroll: true });
        }
        var rect = this.form.getBoundingClientRect();
        if (rect.top < 60) {
          this.form.scrollIntoView({ behavior: reducedQuery.matches ? 'auto' : 'smooth', block: 'start' });
        }
      }
    }

    validate(index) {
      var step = this.steps[index];
      var ok = true;
      var n = parseInt(step.dataset.step, 10);
      if (n === 1) {
        ok = this.needs.some(function (box) { return box.checked; });
      } else if (n === 2) {
        ok = !!step.querySelector('input[type="radio"]:checked');
      } else if (n === 3) {
        var groups = {};
        step.querySelectorAll('input[type="radio"]').forEach(function (r) { groups[r.name] = groups[r.name] || r.checked; });
        ok = Object.keys(groups).every(function (k) { return groups[k]; });
      } else {
        var required = step.querySelectorAll('[required]');
        for (var i = 0; i < required.length; i++) {
          if (!required[i].checkValidity()) {
            ok = false;
            required[i].reportValidity();
            break;
          }
        }
      }
      var err = step.querySelector('[data-step-error]');
      if (err) err.hidden = ok;
      return ok;
    }

    collectNeeds() {
      return this.needs.filter(function (box) { return box.checked; }).map(function (box) { return box.dataset.need; });
    }

    onSubmit(event) {
      for (var i = 0; i < this.steps.length; i++) {
        if (!this.validate(i)) {
          event.preventDefault();
          this.show(i);
          this.validate(i);
          return;
        }
      }
      if (this.needsField) this.needsField.value = this.collectNeeds().join(', ');
      track('byteful_lead_submit', { needs: this.collectNeeds().join(', ') });
    }

    updateBrief() {
      if (!this.brief || !this.briefList) return;
      var rows = [];
      var needs = this.collectNeeds();
      if (needs.length) rows.push(['İhtiyaç', needs.join(', ')]);
      var stage = this.form.querySelector('input[name="contact[Marka durumu]"]:checked');
      if (stage) rows.push(['Durum', stage.value]);
      var budget = this.form.querySelector('input[name="contact[Aylık reklam bütçesi]"]:checked');
      if (budget) rows.push(['Reklam bütçesi', budget.value]);
      var time = this.form.querySelector('input[name="contact[Başlangıç zamanı]"]:checked');
      if (time) rows.push(['Başlangıç', time.value]);
      this.briefList.innerHTML = rows.map(function (row) {
        return '<div><dt>' + escapeHtml(row[0]) + '</dt><dd>' + escapeHtml(row[1]) + '</dd></div>';
      }).join('');
      this.brief.hidden = rows.length === 0;
    }
  }

  function define(name, ctor) {
    if (!window.customElements.get(name)) window.customElements.define(name, ctor);
  }

  define('bd-roas', BdRoas);
  define('bd-growth-score', BdGrowthScore);
  define('bd-speed-test', BdSpeedTest);
  define('bd-planner', BdPlanner);

  /* Form başarıyla gönderildiyse */
  function onReady() {
    var success = document.querySelector('[data-bd-success]');
    if (success) {
      clearNote();
      track('byteful_lead', { form: 'contact' });
      success.focus({ preventScroll: false });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
